// AUTO-GENERATED (Gemini) — section-header translations for the intake wizard.
// Keyed by the raw FR/EN section string stored on questions; questionMapper reads
// section_translations[language]. Regenerate via scratchpad/translate_sections.mjs.
export const SECTION_TRANSLATIONS: Record<string, { fr: string; en: string; es: string }> = {
  "Section A": {
    "fr": "Section A",
    "en": "Section A",
    "es": "Sección A"
  },
  "Part 1 — Engagement": {
    "fr": "Partie 1 — Engagement",
    "en": "Part 1 — Engagement",
    "es": "Parte 1 — Compromiso"
  },
  "Détails du répondant": {
    "fr": "Détails Du Répondant",
    "en": "Sponsor Details",
    "es": "Detalles Del Patrocinador"
  },
  "Coordonnées du répondant": {
    "fr": "Coordonnées Du Répondant",
    "en": "Sponsor Contact Information",
    "es": "Información De Contacto Del Patrocinador"
  },
  "Déclaration de résidence du répondant": {
    "fr": "Déclaration De Résidence Du Répondant",
    "en": "Sponsor Residency Declaration",
    "es": "Declaración De Residencia Del Patrocinador"
  },
  "Examen d'admissibilité du répondant": {
    "fr": "Examen D'admissibilité Du Répondant",
    "en": "Sponsor Eligibility Review",
    "es": "Revisión De Elegibilidad Del Patrocinador"
  },
  "Détails du cosignataire": {
    "fr": "Détails Du Cosignataire",
    "en": "Co-Signer Details",
    "es": "Detalles Del Co-Firmante"
  },
  "Coordonnées du cosignataire": {
    "fr": "Coordonnées Du Cosignataire",
    "en": "Co-Signer Contact Information",
    "es": "Información De Contacto Del Co-Firmante"
  },
  "Déclaration de résidence du cosignataire": {
    "fr": "Déclaration De Résidence Du Cosignataire",
    "en": "Co-Signer Residency Declaration",
    "es": "Declaración De Residencia Del Co-Firmante"
  },
  "Examen d'admissibilité du cosignataire": {
    "fr": "Examen D'admissibilité Du Cosignataire",
    "en": "Co-Signer Eligibility Review",
    "es": "Revisión De Elegibilidad Del Co-Firmante"
  },
  "Renseignements personnels du répondant": {
    "fr": "Renseignements Personnels Du Répondant",
    "en": "Sponsor Personal Information",
    "es": "Información Personal Del Patrocinador"
  },
  "Renseignements personnels du demandeur principal": {
    "fr": "Renseignements Personnels Du Demandeur Principal",
    "en": "Principal Applicant Personal Information",
    "es": "Información Personal Del Solicitante Principal"
  },
  "Partie A — Évaluation du parrainage et renseignements concernant le répondant": {
    "fr": "Partie A — Évaluation Du Parrainage Et Renseignements Concernant Le Répondant",
    "en": "Part A — Sponsorship Assessment And Sponsor Information",
    "es": "Parte A — Evaluación De Patrocinio E Información Del Patrocinador"
  },
  "Partie B — Renseignements concernant le demandeur principal": {
    "fr": "Partie B — Renseignements Concernant Le Demandeur Principal",
    "en": "Part B — Principal Applicant Information",
    "es": "Parte B — Información Del Solicitante Principal"
  },
  "Partie C — Renseignements concernant la relation": {
    "fr": "Partie C — Renseignements Concernant La Relation",
    "en": "Part C — Relationship Information",
    "es": "Parte C — Información De La Relación"
  },
  "APPLICATION DETAILS": {
    "fr": "Détails De La Demande",
    "en": "Application Details",
    "es": "Detalles De La Solicitud"
  },
  "PERSONAL DETAILS": {
    "fr": "Détails Personnels",
    "en": "Personal Details",
    "es": "Datos Personales"
  },
  "CONTACT INFORMATION": {
    "fr": "Coordonnées",
    "en": "Contact Information",
    "es": "Información De Contacto"
  },
  "PASSPORT": {
    "fr": "Passeport",
    "en": "Passport",
    "es": "Pasaporte"
  },
  "NATIONAL IDENTITY DOCUMENT": {
    "fr": "Pièce D'identité Nationale",
    "en": "National Identity Document",
    "es": "Documento Nacional De Identidad"
  },
  "US PR CARD": {
    "fr": "Carte De Résident Permanent Américain",
    "en": "US PR Card",
    "es": "Tarjeta De Residente Permanente De EE. UU."
  },
  "EDUCATION/OCCUPATION DETAIL": {
    "fr": "Détails Scolarité/Profession",
    "en": "Education/Occupation Details",
    "es": "Detalles De Educación/Ocupación"
  },
  "LANGUAGE DETAIL": {
    "fr": "Détails Linguistiques",
    "en": "Language Details",
    "es": "Detalles De Idiomas"
  },
  "DEPENDANT(S)": {
    "fr": "Personne(s) À Charge",
    "en": "Dependant(s)",
    "es": "Dependiente(s)"
  },
  "ANTÉCÉDENTS / DÉCLARATION": {
    "fr": "Antécédents / Déclaration",
    "en": "Background / Declaration",
    "es": "Antecedentes / Declaración"
  },
  "DÉTAILS PARENTAUX": {
    "fr": "Détails Parentaux",
    "en": "Parental Details",
    "es": "Detalles Parentales"
  },
  "ADMISSIBILITÉ": {
    "fr": "Admissibilité",
    "en": "Eligibility",
    "es": "Elegibilidad"
  },
  "SCOLARITÉ": {
    "fr": "Scolarité",
    "en": "Education",
    "es": "Educación"
  },
  "ANTÉCÉDENTS PERSONNELS": {
    "fr": "Antécédents Personnels",
    "en": "Personal Background",
    "es": "Antecedentes Personales"
  },
  "ORGANISATIONS": {
    "fr": "Organisations",
    "en": "Organizations",
    "es": "Organizaciones"
  },
  "CHARGES PUBLIQUES": {
    "fr": "Charges Publiques",
    "en": "Public Office",
    "es": "Cargos Públicos"
  },
  "SERVICE MILITAIRE": {
    "fr": "Service Militaire",
    "en": "Military Service",
    "es": "Servicio Militar"
  },
  "ADRESSES": {
    "fr": "Adresses",
    "en": "Addresses",
    "es": "Direcciones"
  },
  "Renseignements sur votre identité": {
    "fr": "Renseignements Sur Votre Identité",
    "en": "Identity Information",
    "es": "Información Sobre Su Identidad"
  },
  "État matrimonial": {
    "fr": "État Matrimonial",
    "en": "Marital Status",
    "es": "Estado Civil"
  },
  "Adresse du domicile et coordonnées": {
    "fr": "Adresse Du Domicile Et Coordonnées",
    "en": "Home Address And Contact Information",
    "es": "Dirección Del Domicilio E Información De Contacto"
  },
  "Époux(-se) ou conjoint(e) de fait": {
    "fr": "Époux(-se) Ou Conjoint(e) De Fait",
    "en": "Spouse Or Common-Law Partner",
    "es": "Cónyuge O Pareja De Hecho"
  },
  "Enfants à charge": {
    "fr": "Enfants À Charge",
    "en": "Dependent Children",
    "es": "Hijos Dependientes"
  },
  "Expériences de travail au Québec": {
    "fr": "Expériences De Travail Au Québec",
    "en": "Work Experience In Quebec",
    "es": "Experiencia Laboral En Quebec"
  },
  "Séjour actuel au Québec": {
    "fr": "Séjour Actuel Au Québec",
    "en": "Current Stay In Quebec",
    "es": "Estadía Actual En Quebec"
  },
  "Séjours et demandes antérieures": {
    "fr": "Séjours Et Demandes Antérieures",
    "en": "Previous Stays And Applications",
    "es": "Estadías Y Solicitudes Anteriores"
  },
  "Projet d'immigration au Québec": {
    "fr": "Projet D'immigration Au Québec",
    "en": "Quebec Immigration Project",
    "es": "Proyecto De Inmigración En Quebec"
  },
  "Déclarations et consentement": {
    "fr": "Déclarations Et Consentement",
    "en": "Declarations And Consent",
    "es": "Declaraciones Y Consentimiento"
  },
  "Identité": {
    "fr": "Identité",
    "en": "Identity",
    "es": "Identidad"
  },
  "Programme d'études au Québec": {
    "fr": "Programme D'études Au Québec",
    "en": "Study Program In Quebec",
    "es": "Programa De Estudios En Quebec"
  },
  "Bourses d'études": {
    "fr": "Bourses D'études",
    "en": "Scholarships",
    "es": "Becas De Estudio"
  },
  "RESIDENCE": {
    "fr": "Résidence",
    "en": "Residence",
    "es": "Residencia"
  },
  "MARITAL STATUS": {
    "fr": "État Civil",
    "en": "Marital Status",
    "es": "Estado Civil"
  },
  "PREVIOUS MARRIAGE": {
    "fr": "Mariage Antérieur",
    "en": "Previous Marriage",
    "es": "Matrimonio Anterior"
  },
  "LANGUAGES": {
    "fr": "Langues",
    "en": "Languages",
    "es": "Idiomas"
  },
  "STUDY DETAILS": {
    "fr": "Détails Des Études",
    "en": "Study Details",
    "es": "Detalles De Estudio"
  },
  "BACKGROUND INFORMATION": {
    "fr": "Renseignements Généraux",
    "en": "Background Information",
    "es": "Información De Antecedentes"
  },
  "CONSENT": {
    "fr": "Consentement",
    "en": "Consent",
    "es": "Consentimiento"
  },
  "VISIT DETAILS": {
    "fr": "Détails Du Séjour",
    "en": "Visit Details",
    "es": "Detalles De Visita"
  },
  "INTENDED WORK DETAILS": {
    "fr": "Détails Du Travail Prévu",
    "en": "Intended Work Details",
    "es": "Detalles Del Trabajo Previsto"
  },
  "EDUCATION DETAIL": {
    "fr": "Détail Des Études",
    "en": "Education Details",
    "es": "Detalles De Educación"
  },
  "OCCUPATION DETAIL": {
    "fr": "Détail De La Profession",
    "en": "Occupation Details",
    "es": "Detalles De Ocupación"
  },
  "Pièces à téléverser": {
    "fr": "Pièces À Téléverser",
    "en": "Documents To Upload",
    "es": "Documentos Para Cargar"
  },
  "Général": {
    "fr": "Général",
    "en": "General",
    "es": "General"
  }
};
